import { render, staticRenderFns } from "./MilkProduction.vue?vue&type=template&id=96f9125c&"
import script from "./MilkProduction.vue?vue&type=script&lang=js&"
export * from "./MilkProduction.vue?vue&type=script&lang=js&"
import style0 from "./MilkProduction.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports